/** /safeevent/handling range：1-本机，2-全部终端 */
export function toApiHandlingRange (applyScope?: number): number | undefined {
  if (applyScope === 0) return 1
  if (applyScope === 1) return 2
  return undefined
}

export interface SafeEventHandlingRequestParams {
  business_id?: string
  /** 1-封住|阻断|隔离 2-已处置 3-忽略本次告警 4-添加信任 */
  handle_type?: number
  /** 1-本机，2-全部终端 */
  range?: number
  /** 策略名称（封堵 IP/域名时） */
  name?: string
  /** 策略子类型，如 35-IP 访问限制、4-域名访问限制 */
  type?: string
  /** 策略类型，如 15-IP、6-域名 */
  strategy_type?: number
  /** 策略内容 JSON 字符串，字段与各策略模块 strategy 一致 */
  strategy?: string
  /** 应用范围：本机为列表 device_id，全网为空数组 */
  device_list?: string[]
  /** 应用范围分组，固定 -1 */
  group_id?: number
}
